var React = require('react');

function FacebookGroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.748 10.667l.918.598v6.219l-1.225 1.184h-4.636l-1.672-1.668h-2.133v-5c2.484-.003 4.053-2.505 5.459-6.667h1.207v.527l-.666 2.064v2.743h2.748zm6.252-5.667v14c0 2.761-2.238 5-5 5h-14c-2.761 0-5-2.239-5-5v-14c0-2.761 2.239-5 5-5h14c2.762 0 5 2.239 5 5zm-4 5.542l-1.855-1.209h-1.812v-1.166l.667-2.064v-2.103h-3.498c-1.439 4.246-2.834 6.661-4.502 6.666v-.666h-5v9h5l.005-.667h1.662l1.671 1.667h5.64l2.022-1.95v-7.508z"}));
}

FacebookGroup.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = FacebookGroup;

FacebookGroup.default = FacebookGroup;
